import { createContext } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';
import _ from 'lodash';

export type QuestionnaireFormContextType = {
  formMethods: UseFormReturn<FieldValues>;
  getResponseSource: (fieldKey: string) => QuestionnaireApiModels.QuestionnaireResponse['source'];
  setResponseSource: (fieldKey: string, source: QuestionnaireApiModels.QuestionnaireResponse['source']) => void;
  getRowResponseSources: (rowFieldKey: string) => Record<string, QuestionnaireApiModels.QuestionnaireResponse['source']>
  setRowResponseSources: (rowFieldKey: string, source: Record<string, QuestionnaireApiModels.QuestionnaireResponse['source']>) => void;
  getAiRequestId: (fieldKey: string) => string | null;
  setAiRequestId: (fieldKey: string, aiRequestId: string) => void;
  getRowAiRequestIds: (rowFieldKey: string) => Record<string, string | null>
  setRowAiRequestIds: (rowFieldKey: string, source: Record<string, string>) => void;
  setValue: (arg1: {
    key: string;
    value: unknown;
    source?: QuestionnaireApiModels.QuestionnaireResponse['source'];
    aiRequestId?: string;
  }) => void;
};

const QuestionnaireFormContext = createContext<QuestionnaireFormContextType | undefined>(undefined);

export default QuestionnaireFormContext;
